var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function () {
        return [_c('sub-visual', {
          attrs: {
            "title": "개인정보처리방침",
            "src": "/images/sub/sub-visual.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--first page-section--last"
  }, [_c('terms-component', {
    attrs: {
      "code": "privacy-ko"
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }